import { render, staticRenderFns } from "./BotonProcesoTabAp.vue?vue&type=template&id=76db8927&"
import script from "./BotonProcesoTabAp.vue?vue&type=script&lang=js&"
export * from "./BotonProcesoTabAp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports